//_1 Importações
//_2 Validações Yup
//_3 Ligação com API
//_4 Styles
//_5 Formulário Login

//Importações ======================================================================================
//React
import { Controller, useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useState } from 'react';

//MUI
import { Paper, Container, TextField, Stack, Box, Alert } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

//API
import api from "../../Services/api";

//Componentes
import stylesInput from '../../Components/Stepps/InputStyle.module.css'
import { useMediaQuery } from 'react-responsive'
import stylesText from '../../Components/Stepps/Text.module.css';
import styleHeader from '../../Components/Header/styles';
import { Header } from '../../Components/Header';
import logo1 from "../../Assets/logo-pt1.png";
import logo2 from "../../Assets/logo-pt2.png"

//Yup
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from "yup";

//CSS
import BackgroundImg from '../../Components/Background/estiloPages.css';

export function AlterarSenha() {

    const { token } = useParams();

    //_2 Validações yup ===================================================================================
    const [erro, setErro] = useState('');
    const [carregando, setCarregando] = useState(false);
    const navigate = useNavigate();

    const schema = yup.object({

        novaSenha:
            yup.string()
                .min(6, "Tamanho mínimo de 6 caracteres")
                .required("Defina uma senha*"),

        senha:
            yup.string()
                .min(6, "Tamanho mínimo de 6 caracteres")
                .required("Defina uma senha*")
                .oneOf([yup.ref('novaSenha'), null], 'As senhas devem ser idênticas')

    }).required();

    const { handleSubmit, control, formState: { errors } } = useForm({ resolver: yupResolver(schema) });

    //_3 Ligação com API ==================================================================================
    async function onSubmit(data) {
        setCarregando(true);
        console.log(data);

        // para validar:
        schema.isValid(data)
            .then((valid) => {
                // caso esteja validado
                if (valid) {
                    // chamada para a API passando os dados ( `data` ) por parametro

                    api.post('/redefinirSenha/' + token, data)
                        .then(function (response) {
                            // sucesso da api
                            navigate('/restaurarConta/verificacaoEmail/alterarSenha/confirmacaoSenha');

                        })
                        .catch(err => setErro(err.response.data.message.toString()))
                        .finally((response) => {
                            setCarregando(false);
                            console.log(data);

                        });
                } else {
                    // tem algum erro de validação.
                    console.log("erro de validação")
                }
            })
            .catch((err) => console.log('valid', err))
    }

    const titleHeader = useMediaQuery({
        query: '(min-width: 640px)'
    })

    return (
        <div className="BackgroundImg">
           <Header/>

            <Container sx={{ pt: '8vh' }}>

                <Paper sx={{ p: 4, maxWidth: 720, margin: 'auto', borderRadius: '16px' }}>
                    <Box sx={{ mb: 3, position: 'relative' }}>
                        <p className={stylesText.titulo}>
                            Crie uma nova senha !
                        </p>
                    </Box>

                    {/*_5 Formulário Login ============================================================================================= */}
                    <form onSubmitCapture={handleSubmit(onSubmit)} >
                        <Stack spacing={1} >
                            <Controller
                                control={control}
                                name="novaSenha"
                                render={({ field }) => (
                                    <>
                                        <TextField
                                            type="password"
                                            minLength="6"
                                            placeholder="Insira a sua nova senha*"
                                            {...field}  // importante
                                        />
                                        <p
                                            style={{
                                                color: 'red',
                                                marginTop: '8px',
                                                display: 'flex'
                                            }}
                                        >
                                            {errors.novaSenha?.message}
                                        </p>
                                    </>
                                )}
                            />

                            <Controller
                                control={control}
                                name="senha"
                                render={({ field }) => (
                                    <>
                                        <TextField
                                            type="password"
                                            minLength="6"
                                            placeholder="Insira a sua nova senha*"
                                            {...field}  // importante
                                        />
                                        <p
                                            style={{
                                                color: 'red',
                                                marginTop: '8px',
                                                display: 'flex'
                                            }}
                                        >
                                            {errors.senha?.message}
                                        </p>
                                    </>
                                )}
                            />

                            {erro &&
                                <Alert severity='error'>
                                    {erro}
                                </Alert>
                            }

                            <Stack direction='row' style={{ width: '100%' }}>
                                <LoadingButton
                                    style={{
                                        backgroundColor: '#3F51b5',
                                        padding: '14px',
                                        borderRadius: '12px',
                                        width: '100%'
                                    }}
                                    fullWidth
                                    loading={carregando}
                                    variant='contained'
                                    type='submit' // importante
                                    disableElevation
                                >
                                    Enviar
                                </LoadingButton>
                            </Stack>
                        </Stack>
                    </form>
                </Paper>

            </Container>
        </div >
    );
}